type Props = Readonly<{
  title: string;
  subtitle: string;
}>;

export const AuthHeading = ({ title, subtitle }: Props) => {
  return (
    <div className="flex flex-col items-center text-center">
      <h1 className="mb-2 text-xl font-semibold">{title}</h1>
      <p className="text-balance text-sm text-muted-foreground">{subtitle}</p>
    </div>
  );
};
